import React from "react";

const MessageBubble = ({ msg, formatDateTime }) => {
  const isAdmin = msg.senderRole === "admin";

  const senderName = isAdmin
    ? "Administration"
    : `${msg.sender?.firstname || ""} ${msg.sender?.lastname || ""}`.trim() || "Utilisateur";

  return (
    <div className={`flex ${isAdmin ? "justify-end" : "justify-start"}`}>
      <div className={`group relative max-w-[85%] rounded-2xl px-4 py-3 shadow-sm ${
        isAdmin ? "bg-cyan-600 text-white" : "border border-slate-700 bg-slate-800 text-slate-100"
      }`}>
        <div className="mb-2 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <p className="text-xs font-semibold opacity-80">{senderName}</p>
            {!isAdmin && !msg.isRead && (
              <span className="rounded-full bg-red-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-red-300">
                Non lu
              </span>
            )}
          </div>
          {msg.createdAt && (
            <span className="text-[11px] opacity-60 transition group-hover:opacity-100">
              {formatDateTime(msg.createdAt)}
            </span>
          )}
        </div>
        <p className="whitespace-pre-wrap break-words text-sm leading-6">{msg.message}</p>
        {isAdmin && (
          <div className="mt-2 text-right text-[11px] text-white/70">
            {msg.isRead ? "Vu par l'utilisateur" : "Envoyé"}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;